module.exports = __webpack_public_path__ + "img/video-thum.75ae108c.png";